<template>
<div style="height: 100%;">
    <div id="d007" class="" style="height: 100%;"></div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Value from '@/views/Value.vue'
    import More from 'highcharts/highcharts-more';
    import Vue from 'vue';
    import { colors } from '@/config';

    More(Highcharts);

    export default {
        name: "D007",
        components: {},
        props: {
            balance: Object
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'waterfall',
                    renderTo: 'd007',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },

                title: {
                    text: ''
                },

                xAxis: {
                    type: 'category',
                    labels: { 
                        style: { fontSize: '1.2rem', } 
                    } 
                },

                yAxis: {
                    title: {
                        text: ''
                    },
                    labels: {
                        style: {
                            fontSize: '1.2rem',
                         },
                        formatter() { return Vue.options.filters.KR(this.value); },
                    },
                    tickPixelInterval: 150
                },

                legend: {
                    enabled: false,
                },

                tooltip: {
                    headerFormat: '<span style="font-size: 1.5rem">{point.key}</span><br/>',
                    pointFormat: '<span><b>{point.y:,.0f} tkr</b></span>',
                    style: {
                        fontSize: '1.5rem',
                    },
                },

                series: [{
                    upColor: colors.Primary,
                    color: colors.Tertiary,
                    data: [
                        {
                            name: 'Tecknat, men ej inbetalt kapital',
                            y: this.balance.A,
                        }, {
                            name: 'Anläggnings-tillgångar',
                            y: this.balance.E
                        }, {
                            name: 'Varulager',
                            y: this.balance.F
                        }, {
                            name: 'Övriga omsättnings-tillgångar',
                            y: this.balance.K - this.balance.F
                        }, {
                            name: 'Balans-omslutning',
                            isIntermediateSum: true,
                            color: colors.Secondary,
                        }, {
                            name: 'Kortfristiga skulder',
                            y: -this.balance.Q
                        }, {
                            name: 'Långfristiga skulder',
                            y: -this.balance.P
                        }, {
                            name: 'Avsättningar',
                            y: -this.balance.O
                        }, {
                            name: 'Obeskattade reserver',
                            y: -this.balance.N,
                            color: colors.LightGrey
                        }, {
                            name: 'Eget kapital',
                            isSum: true,
                            color: colors.Green,
                            negativeColor: colors.Red
                        },
                    ].filter( (o, i) => o.y !== 0 || i > 0 ),

                    pointPadding: 0
                }]
            });
        },

    }
</script>

<style scoped>
 
</style>
